import styled from 'styled-components/macro';

export const StyledHeader = styled.header`
 display: flex;
 flex-direction: row;
`

export const HomeButton = styled.button`
height: fit-content;
background: none;
color: inherit;
border: none;
padding: 5px;
font: inherit;
cursor: pointer;
outline: inherit;
`
export const Logo = styled.img`
height: 8vh;
`
